import { useMemo } from "react";

/**
 * Variantes posibles para la sección de compactación.
 */
export const COMPACTAR_VARIANT = {
  /** Ya fue compactado: se muestra el badge informativo. */
  YA_COMPACTADO: "ya_compactado",
  /** Estado "a compactar" y juzgado lo bloquea. */
  BLOQUEADO_JUZGADO: "bloqueado_juzgado",
  /** Estado "a compactar" y juzgado lo permite. */
  PUEDE_COMPACTAR: "puede_compactar",
  /** Estado "a compactar" sin infoJuzgado: queda a criterio del corralón. */
  SIN_INFO: "sin_info",
  /** Estado "no compactar": bloqueado desde corralón. */
  BLOQUEADO_CORRALON: "bloqueado_corralon",
  /** Cualquier otro estado: no se muestra la sección. */
  OCULTO: "oculto",
};

/**
 * Deriva la variante de compactación a mostrar en DetailComponent.
 *
 * @param {{ infoJuzgado: object|null }} detail
 * @param {string} estado - Estado normalizado (de useEstado)
 * @param {{ COMPACTADO: string, A_COMPACTAR: string, NO_COMPACTAR: string }} ESTADO
 * @returns {{ variant: string }}
 */
export function useCompactarStatus(detail, estado, ESTADO) {
  const variant = useMemo(() => {
    if (estado === ESTADO.COMPACTADO) return COMPACTAR_VARIANT.YA_COMPACTADO;

    if (estado === ESTADO.A_COMPACTAR) {
      if (detail.infoJuzgado !== null) {
        return detail.infoJuzgado?.compactar
          ? COMPACTAR_VARIANT.PUEDE_COMPACTAR
          : COMPACTAR_VARIANT.BLOQUEADO_JUZGADO;
      }
      return COMPACTAR_VARIANT.SIN_INFO;
    }

    if (estado === ESTADO.NO_COMPACTAR) return COMPACTAR_VARIANT.BLOQUEADO_CORRALON;

    return COMPACTAR_VARIANT.OCULTO;
  }, [estado, ESTADO, detail.infoJuzgado]);

  return { variant };
}